module.exports = __webpack_public_path__ + "img/Enamel1.18fbee35.jpg";